var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifi = function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.01 18.46a.6.6 0 0 1 0 1.199H12a.6.6 0 1 1 0-1.2zM12 13.752c1.389 0 2.723.545 3.715 1.517a.601.601 0 0 1-.84.857 4.11 4.11 0 0 0-5.749 0 .6.6 0 0 1-.84-.857A5.3 5.3 0 0 1 12 13.753m0-4.705c2.62 0 5.137 1.027 7.008 2.862a.6.6 0 0 1-.84.857 8.814 8.814 0 0 0-12.337 0 .6.6 0 0 1-.84-.857A10.01 10.01 0 0 1 12 9.048m0-4.706c3.62 0 7.114 1.334 9.812 3.747a.6.6 0 0 1-.8.895 13.52 13.52 0 0 0-18.024 0 .6.6 0 0 1-.8-.895A14.72 14.72 0 0 1 12 4.342"
  })));
};
export default SvgWifi;